import {loadYaml} from '@/script/common';

interface ImageInfo { name: string; url: string; }

export default class ImageManager {
  // シングルトン
  public static get INSTANCE(): ImageManager {
    if (!ImageManager._INSTANCE) {
      ImageManager._INSTANCE = new ImageManager();
    }
    return ImageManager._INSTANCE;
  }
  private static _INSTANCE: ImageManager;

  public imageMap: ImageInfo[] = [];

  // コンストラクタの隠蔽
  private constructor() {}

  public async init() {
    const imageDataList: any[] = await loadYaml('config/image.yaml');
    imageDataList.forEach((imageData: any) => {
      const url = `${process.env.VUE_APP_IMAGE_BASE_URL}${imageData.path}`;
      this.imageMap.push({
        name: imageData.name,
        url,
      });
    });
  }

  public get(name: string) {
    const imageInfo = this.imageMap.filter((image) => image.name === name)[0];
    return imageInfo ? imageInfo.url : null;
  }
}
